export default "<div class=\"full-width\">\n  <lib-resource-cloud-detail #createForm\n  [navigationMode]=false>\n  </lib-resource-cloud-detail>\n</div>"